/*
Sohel 01/23/2023 2698964415 Search Form for Audit Fields
Sohel 01/23/2023 2698964415 Added Audit Fields
Suresh Peddavoora 02/16/2023 2698964415 TextFields alignments in export template Record
Sohel 02/21/2023 2698964415 Audit Field List Changes
suresh peddavoora 03/06/2023 2698964415 textfield alignments fixes
Dilip 02/29/2023 2698964415 Fixed reset issue
Prakash 03/29/2023 2698964415 Fixed responsiveness issues for reset and search buttons.
*/
import {Button, TextField} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useState, useRef, useContext} from 'react';
import {filteredCheckedFieldTypeData, tempSelectFieldTypeFunc} from '../../../../../../util/Functions';
import {useSelector, useDispatch} from 'react-redux';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {
  getBaseCategory,
  getFieldType,
} from '../../../../../../redux/reducers/GlobalField/AddFieldList';
import SearchTable from './SearchTable';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
const SearchForm = ({
  setAuditFieldValue,
  dmValues,
  setTempSelectedRows,
  tempSelectedRows,
  handleClose,
  deletedProcessorFields,
  dmRecordCategory,
  deletedIds,
  setDeletedIds,
  isRecordFormat = false,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const tempUnCheckedRef = useRef();
  const {baseCategoryData, fieldTypeData} = useSelector(({addFieldList}) => addFieldList);
  const initialState = {
    category: dmRecordCategory,
    fieldName: '',
    fieldType: '',
    repositoryName: '',
  };

  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    setSearchData({...initialState, category: dmRecordCategory});
  }, [dmRecordCategory]);
  const onClear = () => {
    const data = {
      category: dmRecordCategory,
      fieldName: '',
      fieldType: '',
      repositoryName: '',
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getBaseCategory());
    dispatch(getFieldType());
  }, []);
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);

  return (
    <>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialState}
          enableReinitialize
        >
          {(props) => {
            const {values, handleBlur, handleChange, handleReset, handleSubmit, setFieldValue} =
              props;
            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="form-row global-field-textfields new-standard-textfields">
                    <div className="col-sm-6 col-md-3 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="category"
                        id="category"
                        size="small"
                        value={values.category}
                        disabled
                        options={baseCategoryData || []}
                        getOptionLabel={(option) => {
                          return option && option?.categoryName ?
                            option?.categoryCode === null ?
                              option?.categoryName :
                              option?.categoryCode + ' - ' + option?.categoryName :
                            '';
                        }}
                        autoHighlight
                        onChange={(e, value) => {
                          setFieldValue('category', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Category"
                              placeholder="Select Category"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-3 col-xl-3 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        placeholder="Enter Repository Name"
                        margin="dense"
                        name="repositoryName"
                        value={values.repositoryName}
                        variant="outlined"
                        label="Repository Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue('repositoryName', e.target.value);
                        }}
                        fullWidth
                      />
                    </div>

                    <div className={`col-sm-6 col-xs-6 col-md-3 col-lg-3 col-xl-3`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="fieldType"
                        id="fieldType"
                        size="small"
                        options={fieldTypeData || []}
                        getOptionLabel={(option) => {
                          return option ? option : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('fieldType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Field Type"
                              placeholder="Select Field Type"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-3 col-xl-3 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        placeholder="Enter Field Name"
                        margin="dense"
                        name="fieldName"
                        value={values.fieldName}
                        variant="outlined"
                        label="Field Name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        fullWidth
                      />
                    </div>
                    <div className="col-md-12 form-group">
                      <div className="form-row">
                        <div className="col-md-7">
                          <div className="d-flex justify-content-end">
                            <Button
                              variant="outlined"
                              className={`mr-1 reset-btn`}
                              onClick={() => {
                                handleReset();
                                setSubmit(true);
                                onClear();
                              }}
                            >
                        Reset
                            </Button>
                            <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                        Search
                            </Button>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="d-flex justify-content-end">
                            <Button
                              variant="outlined"
                              className={`reset-btn mr-1`}
                              onClick={() => {
                                handleClose();
                              }}
                            >
                        Close
                            </Button>
                            <Button
                              variant="outlined"
                              className={`search-btn ml-1`}
                              onClick={() => {
                                if (dmValues && !isRecordFormat) {
                                  const obj = tempSelectFieldTypeFunc(
                                    'fieldName',
                                    'repositoryName',
                                    'processorFieldType',
                                    tempUnCheckedRef,
                                  );
                                  const [newSelectedRows, newUnSelectedRows] = filteredCheckedFieldTypeData(
                                    dmValues.selectedFields,
                                    obj,
                                    'fieldName',
                                    'repositoryName',
                                    'processorFieldType',
                                  );
                                  const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                  setAuditFieldValue('selectedFields', allSelectedRows);
                                  if (newUnSelectedRows.length > 0) {
                                    const allDeleteIds = [];
                                    newUnSelectedRows.forEach((el) => {
                                      if (el.processorId) {
                                        allDeleteIds.push(el.processorId);
                                      }
                                    });
                                    if (allDeleteIds.length > 0) {
                                      deletedProcessorFields.current = [
                                        ...deletedProcessorFields.current,
                                        ...allDeleteIds,
                                      ];
                                    } else {
                                      deletedProcessorFields.current = [
                                        ...deletedProcessorFields.current,
                                        0,
                                      ];
                                    }
                                  }
                                }
                                if (isRecordFormat && dmValues) {
                                  const obj1 = tempSelectFieldTypeFunc(
                                    'fieldName',
                                    'repositoryName',
                                    'mapFieldType',
                                    tempUnCheckedRef,
                                  );
                                  const [newSelectedRows, newUnSelectedRows] = filteredCheckedFieldTypeData(
                                    dmValues.selectedFields,
                                    obj1,
                                    'fieldName',
                                    'repositoryName',
                                    'mapFieldType',
                                  );
                                  const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                  setAuditFieldValue('selectedFields', allSelectedRows);
                                  if (newUnSelectedRows.length > 0) {
                                    const allDeleteIds = [];
                                    newUnSelectedRows.forEach((el) => {
                                      if (el.dataManagerRecordFieldId) {
                                        allDeleteIds.push(el.dataManagerRecordFieldId);
                                      }
                                    });

                                    const ids = [...deletedIds, ...allDeleteIds];
                                    setDeletedIds(ids);
                                  }
                                }
                                setTempSelectedRows([]);
                                handleClose();
                              }}
                            >
                        Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
        <SearchTable
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          setAuditFieldValue={setAuditFieldValue}
          dmValues={dmValues}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          handleClose={handleClose}
          deletedProcessorFields={deletedProcessorFields}
          dmRecordCategory={dmRecordCategory}
          tempUnCheckedRef={tempUnCheckedRef}
          isRecordFormat={isRecordFormat}
        />
      </div>
    </>
  );
};
export default SearchForm;
